import { init, setTag, setUser } from '@sentry/react';
import { useAuth } from 'services/providers/auth.provider';

/**
 * GlitchTip / Sentry setup.
 *  - only enabled when the DSN is provided,
 *  - tracks app version
 *
 * GlitchTip server is a fork of Sentry, so we can use sentry libraries for setup
 */
export default function setupGlitchTip(): void {
  if (GLITCHTIP_DSN) {
    init({
      dsn: GLITCHTIP_DSN,
      environment: SITE_ENV,
      release: APP_VERSION,
      attachStacktrace: true,
      ignoreErrors: ['ChunkLoadError']
    });
  }
}

/**
 * Track the currently authenticated user in GlitchTip / Sentry error reporting
 *  - track id, email, username, and customer name (school / organisation)
 *  - clears tracking when authentication expires (logout)

 *  GlitchTip server is a fork of sentry, so we can use sentry libraries for setup
 */
export function TrackUser(): null {
  const auth = useAuth();

  if (auth.me) {
    setUser({
      id: `${auth.me.id}`,
      email: auth.me.email,
      username: auth.me.username
    });
    setTag('customer', auth.me.customer?.name);
  } else {
    setUser(null);
    setTag('customer', null);
  }

  return null;
}
